import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["headers", "params"];
import { XSRF_HEADER } from "./constants";
import { getSessionKey, getSessionID, genConditionalParams } from "./internalUtils";
var randomStringOfLength = function randomStringOfLength(length) {
  var result = "";
  var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var CHARSET_LENGTH = CHARSET.length;
  var counter = 0;
  while (counter < length) {
    result += CHARSET.charAt(Math.floor(Math.random() * CHARSET_LENGTH));
    counter += 1;
  }
  return result;
};

/**
 * This function generates a string to be used as a trace ID for a Halo request. It just needs to be
 * random enough to identify requests made at the exact same time. So we just generate a random string
 * and append it to the current timestamp.
 */
export var generateTraceId = function generateTraceId() {
  return "".concat(randomStringOfLength(16), "-").concat(Date.now());
};
var getHaloHeaders = function getHaloHeaders() {
  var _requiredHeaders;
  var requiredHeaders = (_requiredHeaders = {}, _defineProperty(_requiredHeaders, XSRF_HEADER, getSessionKey()), _defineProperty(_requiredHeaders, "x-smar-trace-id", generateTraceId()), _requiredHeaders);
  var sessionID = getSessionID();
  if (sessionID) {
    requiredHeaders["Smartsheet-sid"] = sessionID;
  }
  return requiredHeaders;
};

/**
 * Generates an axios configuration to be used for a Halo request.
 * A trace ID will be automatically generated for the request.
 * @param config A partial axios request configuration that will be merged
 * with the default request configuration.
 */
export var genHaloConfig = function genHaloConfig(config) {
  var requiredHeaders = getHaloHeaders();
  var requiredParams = genConditionalParams([["publishKey", "pk"], ["embedData", "embedData"], ["updateTicket", "ux"]]);
  var _ref = config !== null && config !== void 0 ? config : {},
    inputHeaders = _ref.headers,
    inputParams = _ref.params,
    restOfConfig = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread({
    withCredentials: true,
    headers: _objectSpread(_objectSpread({}, requiredHeaders), inputHeaders),
    params: _objectSpread(_objectSpread({}, requiredParams), inputParams)
  }, restOfConfig);
};
//# sourceMappingURL=halo.js.map